import React, { PureComponent } from 'react';
import b from 'b_';

import './dataset-item.stub.css';

import Rect from '@components/rect';

interface Props {
    type: 'horizontal' | 'vertical';
}

const class_ = b.with('dataset-item-stub');

export default class DatasetItemStub extends PureComponent<Props> {
    public render() {
        const { type } = this.props;

        return (
            <div className={class_({ type })}>
                <Rect
                    className={class_('title')}
                    width={'100%'}
                    height={20}
                    type="black"
                />
                <Rect
                    className={class_('description')}
                    width={'100%'}
                    height={50}
                />
                <Rect
                    className={class_('date')}
                    width={120}
                    height={20}
                />
            </div>
        );
    }
}
